import Parse from 'parse'

const state = {
  bank: null,
  name: '',
  branchName: '',
  accountType: null,
  accountNumber: ''
}

const mutations = {
  setBank (state, bank) {
    state.bank = bank
  },

  setName (state, name) {
    state.name = name
  },

  setBranchName (state, branchName) {
    state.branchName = branchName
  },

  setAccountType (state, accountType) {
    state.accountType = accountType
  },

  setAccountNumber (state, accountNumber) {
    state.accountNumber = accountNumber
  }
}

const actions = {
  async fetchBank ({ commit }) {
    let query = new Parse.Query('Bank')
    query.equalTo('user', Parse.User.current().id)
    const bank = await query.first()
    commit('setBank', bank)
  },

  resetAttrs ({ state, commit }) {
    const bank = state.bank
    commit('setName', bank.get('name'))
    commit('setBranchName', bank.get('branchName'))
    commit('setAccountType', bank.get('accountType'))
    commit('setAccountNumber', bank.get('accountNumber'))
  },

  async saveName ({ state }) {
    const bank = state.bank
    bank.set('name', state.name)
    await bank.save()
  },

  async saveBranchName ({ state }) {
    const bank = state.bank
    bank.set('branchName', state.branchName)
    await bank.save()
  },

  async saveAccountType ({ state }) {
    const bank = state.bank
    bank.set('accountType', state.accountType)
    await bank.save()
  },

  async saveAccountNumber ({ state }) {
    const bank = state.bank
    bank.set('accountNumber', state.accountNumber)
    await bank.save()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
